import { plainDate } from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { forecastFrequency } from "./get-sku-sales-forecast";

export const upsertForecastAdjustmentsForPeriod = {
  name: "upsertForecastAdjustmentsForPeriod" as const,
  input: z.object({
    sku: z.string().min(1),
    frequency: createEnum(forecastFrequency),
    date: plainDate(),
    adjustment: z.number().int(),
  }),
  output: z.object({ success: z.boolean() }),
};
